var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveySet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6577_41149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1663 29.5204V26.6429H26.4997L22.9997 22.8061H7.83301V29.5204",
    stroke: "#CCD3E0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1663 23.7653V20.8878H26.4997L22.9997 17.051H7.83301V19.9286",
    stroke: "#CCD3E0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1663 18.0102V15.1326H26.4997L22.9997 11.2959H7.83301V14.1735",
    stroke: "#CCD3E0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0003 33.3571V36.2347H23.0003V33.3571H3.16699V52.5408H56.8337V33.3571H37.0003Z",
    stroke: "#CCD3E0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 41.9898H23V45.8265H37V41.9898Z",
    stroke: "#CCD3E0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16699 29.5204V7.45918H56.8337V29.5204",
    stroke: "#CCD3E0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.333 26.6429H20.6663",
    stroke: "#CCD3E0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6577_41149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 47,
    fill: "white",
    transform: "translate(2 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveySet);
export default __webpack_public_path__ + "static/media/survey-set.ac1288c99d682cf6f089f4fc3641ee0c.svg";
export { ForwardRef as ReactComponent };